import React, { useMemo } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useLocalizedStrings } from 'app/localization/Context';

import { ReactComponent as IconStable } from 'images/connection/stable.svg';
import { ReactComponent as IconLoading } from 'images/connection/connecting.svg';

import "./ConnectionStatus.css";

export const ConnectionStatusValues = {
    connecting: "connecting",
    updating: "updating",
    stable: "stable",
};

const animationPageVariants = {
    initial: {
        opacity: 0,
    },
    animate: {
        opacity: 1,
    },
    exit: {
        opacity: 0,
    }
};

const animationTransition = {
    duration: 0.8
}

function AnimationContainer(props) {
    return (
        <motion.div
            initial="initial"
            animate="animate"
            exit="exit"
            variants={animationPageVariants}
            transition={animationTransition}

            className={props.className}
        >
            {props.children}
        </motion.div>
    );
}

function ConnectionStatus({ connectionStatus }) {
    const icon = useMemo(() => {
        if (connectionStatus === "stable") {
            return <AnimationContainer className="icon-container">
                <IconStable className="ok-image" />
            </AnimationContainer>
            // return <IconStable className="ok-image" />;
        } else {
            return <AnimationContainer className="icon-container">
                <IconLoading className="loading-image" />
            </AnimationContainer>
            // return <IconLoading className="loading-image" />;
        }
    }, [connectionStatus]);

    const s = useLocalizedStrings();

    const statusToShow = useMemo(() => {
        switch (connectionStatus) {
            case "connecting":
                return s.statusConnecting;
            case "updating":
                return s.statusUpdating;
            case "stable":
                return s.statusStable;
            default:
                return "";
        }
    }, [connectionStatus, s]);

    return (
        <div className={"home-connection-status " + connectionStatus}>
            <div />
            <AnimationContainer className="label">{statusToShow}</AnimationContainer>
            <AnimatePresence mode='wait'>
                {icon}
            </AnimatePresence>
            {/* <AnimationContainer className="icon-container">{icon}</AnimationContainer> */}
            <div />
        </div>
    )
}

export default ConnectionStatus;